import { createTranslations } from '@npco/utils-translations'

export const savingsAccountHeaderTranslations = createTranslations({
  savingsAccount: 'Zeller Savings Account',
  activate: 'Activate Now',
  rate: 'Earn {effectiveInterestRate}% p.a.',
})
